import { useNavigate } from "@tanstack/react-router";
import { useIntl } from "react-intl";

import { Button } from "@/components/Button";
import { PersistentDrawer } from "@/components/Drawer";
import { ReservationDocumentList } from "@/features/bookings/components/ReservationDocumentList";
import type { FindOrderByIdAndUserIdOutputData } from "@/types/codegen";

type Props = {
  orderData?: FindOrderByIdAndUserIdOutputData;
  inDrawer?: boolean;
};

const SectionContent = ({ orderData }: Props) => {
  const navigate = useNavigate();
  const intl = useIntl();

  return (
    <>
      {orderData?.reservations.map((reservation) => (
        <ReservationDocumentList
          key={reservation.id}
          reservationId={reservation.reservationId}
        />
      ))}
      <Button
        variant="outlined"
        fullWidth
        onClick={() =>
          navigate({ to: "/bookings", search: { category: "hotels" } })
        }
      >
        {intl.formatMessage({
          defaultMessage: "Manage My Trips",
          description:
            "Button on hotel booking success screen redirecting user to My Trips",
        })}
      </Button>
    </>
  );
};

export const BookedHotelDocumentsSection = ({ inDrawer, orderData }: Props) => {
  return (
    <>
      <SectionContent orderData={orderData} />
      {inDrawer ? (
        <PersistentDrawer open={inDrawer}>
          <SectionContent orderData={orderData} />
        </PersistentDrawer>
      ) : null}
    </>
  );
};
